import styled from "styled-components";
const ValueImprovementSub = ({ number, title, text }) => {
  return (
    <Div>
      <div>
        <div>{number}</div>
        <div>{title}</div>
      </div>
      <hr />
      <div>{text}</div>
    </Div>
  );
};
export default ValueImprovementSub;
const Div = styled.div`
  border-radius: 1.25rem;
  border: 1px solid ${({ theme }) => theme.colors.line};
  background-color: white;
  padding: 2rem 1.75rem;
  & > div:first-child {
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
    & > div:first-child {
      font-size: 0.85rem;
      font-weight: 800;
      color: ${({ theme }) => theme.colors.accent};
    }
    & > div:nth-child(2) {
      font-size: 1.3rem;
      font-weight: 800;
      color: ${({ theme }) => theme.colors.dark};
    }
  }
  & > hr {
    border: 0;
    border-top: 1px solid ${({ theme }) => theme.colors.line};
    margin: 1.25rem 0;
  }
  & > div:nth-child(3) {
    line-height: 1.8;
    color: ${({ theme }) => theme.colors.monotone.dark};
  }
`;
